import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillSpam = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.27 2.62L21.39 6.74C21.77 7.14 22 7.69 22 8.25v7.5c0 .56-.23 1.11-.61 1.51l-4.12 4.12a2.14 2.14 0 01-1.51.62H8.24c-.56 0-1.11-.23-1.51-.62L2.62 17.26A2.14 2.14 0 012 15.75V8.24c0-.56.23-1.11.62-1.51L6.74 2.62c.4-.4.95-.62 1.51-.62h7.52c.56 0 1.11.23 1.51.62z"
      fill="currentColor"
    />
    <rect x="11" y="6.5" width="2" height="8" fill="#fff" />
    <circle cx="12" cy="17" r="1" fill="#fff" />
  </svg>
)

export default withDefaultStyles(FillSpam)
